import React from 'react'
import { Input, Card, Tooltip } from 'antd'
import { useFormikContext } from 'formik'
import { FormField } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

const { TextArea } = Input

export const AboutOverviewSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const titlePath = useFieldPath('sections.aboutOverview.title')
  const textPath = useFieldPath('sections.aboutOverview.text')
  const htmlPath = useFieldPath('sections.aboutOverview.html')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>Título</label>
        <Input
          name={titlePath}
          value={get(values, titlePath, '')}
          onChange={handleChange}
          placeholder="Sobre o curso"
        />
      </FormField>
      <FormField>
        <label>
          <Tooltip title="Texto simples que será dividido em parágrafos automaticamente (use quebras duplas de linha)">
            Texto (Plain Text)
          </Tooltip>
        </label>
        <TextArea
          name={textPath}
          value={get(values, textPath, '')}
          onChange={handleChange}
          rows={8}
          placeholder="Texto descritivo do curso. Use quebras duplas de linha para separar parágrafos."
        />
      </FormField>
      <FormField>
        <label>
          <Tooltip title="HTML formatado (usa dangerouslySetInnerHTML). Se preenchido, tem prioridade sobre 'Texto'">
            HTML (Opcional)
          </Tooltip>
        </label>
        <TextArea
          name={htmlPath}
          value={get(values, htmlPath, '')}
          onChange={handleChange}
          rows={8}
          placeholder="HTML formatado (opcional, tem prioridade sobre texto simples)"
        />
      </FormField>
    </Card>
  )
}
